import globals from '@shared/globals';

export const redirectThankYouPage = () => {
	const ITYP_NAME = 'dhsv_ityp';

	const pageUrl = new URL( window.location.href );
	const queryParams = pageUrl.search;
	const currentUrl = pageUrl.origin + pageUrl.pathname;

	if (
		currentUrl === globals.formRedirect.default ||
		currentUrl === globals.formRedirect.gfDefault
	) {
		// Check if current page is loaded for the first time
		if ( ! window.sessionStorage.hasOwnProperty( ITYP_NAME ) ) {
			window.sessionStorage.setItem( ITYP_NAME, 'crm-redirect-auto' );
		}

		const ITYP_VALUE = window.sessionStorage.getItem( ITYP_NAME );

		if ( ITYP_VALUE ) {
			const crmUrl = globals.formRedirect.gfDefault
				? globals.formRedirect.gfCrm
				: globals.formRedirect.crm;
			const redirectURL = crmUrl ? crmUrl + queryParams : '';

			const handleRedirect = () => {
				if ( redirectURL ) {
					window.location.replace( redirectURL );
				}
			};

			if ( ITYP_VALUE === 'crm-redirect-auto' ) {
				window.sessionStorage.setItem( ITYP_NAME, 'crm-redirect' );
				setTimeout( handleRedirect, 3600000 ); // 1 hour in milliseconds
			} else if ( ITYP_VALUE === 'crm-redirect' ) {
				handleRedirect();
			}
		}
	} else {
		window.sessionStorage.removeItem( ITYP_NAME );
	}
};
